// extracted by mini-css-extract-plugin
module.exports = {"table":"EquipmentWithMostIncidentsTile_table__3bsZH","index":"EquipmentWithMostIncidentsTile_index__2zU17"};